var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonAddOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7C13 8.78947 11.7895 10 10 10C8.21053 10 7 8.78947 7 7C7 5.21053 8.21053 4 10 4C11.7895 4 13 5.21053 13 7ZM15 7C15 4.22807 12.7719 2 10 2C7.22807 2 5 4.22807 5 7C5 9.77193 7.22807 12 10 12C12.7719 12 15 9.77193 15 7ZM10 15C14.193 15 17 16.4035 17 18C17 19.2281 16.2281 20 15 20H5C3.77193 20 3 19.2281 3 18C3 16.4035 5.80702 15 10 15ZM10 13C5.17544 13 1 15.0175 1 18C1 20.2105 2.78947 22 5 22H15C17.2105 22 19 20.2105 19 18C19 15.0175 14.8246 13 10 13ZM18 8V14C18 14.5439 18.4561 15 19 15C19.5439 15 20 14.5439 20 14V8C20 7.45614 19.5439 7 19 7C18.4561 7 18 7.45614 18 8ZM16 12H22C22.5439 12 23 11.5439 23 11C23 10.4561 22.5439 10 22 10H16C15.4561 10 15 10.4561 15 11C15 11.5439 15.4561 12 16 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAddOutlined);
export default __webpack_public_path__ + "static/media/person_add_outlined.c21c54a0.svg";
export { ForwardRef as ReactComponent };